module.exports = __webpack_public_path__ + "static/media/grzanie.452f75ef.svg";